<div class="attachment-audio-wrapper">
  <div>{{attachment.filename}}</div>
  <div class="download-wrapper" *ngIf="isAllowAttachmentSave">
    <button class="btn tn-button-primary" [disabled]="isDisableDownload" (click)="downloadFile()">
      {{'GENERAL.DOWNLOAD' | translate}}
    </button>
  </div>
</div>
<tn-audio-player style="display: flex;justify-content: center;" [audioUrl]="audioUrl" [mimeType]="mimeType" *ngIf="audioUrl"></tn-audio-player>